import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import {
  Headers,
  Request,
  RequestOptions,
  RequestMethod,
  Response,
} from "@angular/http";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/do";
import "rxjs/add/observable/throw";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { ErrorObservable } from "rxjs/observable/ErrorObservable";
import { catchError, retry } from "rxjs/operators";
import { AuthService } from ".././auth/auth.service";
import { Router } from "@angular/router";
import { Logging } from "../../logging";

@Injectable()
export class ApiService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private router: Router
  ) {}

  retryTimes: number = 1;

  //Custom Request Method
  request(url: string, method: string, body?: Object) {
    // Add the base url to the uri sent
    const full_url: string = `${this.baseUrl}${url}`;

    //Send Rerquest for GET
    if (method == "GET") {
      return this.http.get(full_url).pipe(
        //retry(this.retryTimes), // retry a failed request up to retryTimes
        catchError(this.handleError) // then handle the error
      );
    }

    //Send Rerquest for POST
    if (method == "POST") {
      return this.http.post(full_url, body).pipe(
        // retry(this.retryTimes), // retry a failed request up to retryTimes
        catchError(this.handleError) // then handle the error
      );
    }

    //Send Rerquest for PUT
    if (method == "PUT") {
      return this.http.put(full_url, body).pipe(
        //retry(this.retryTimes), // retry a failed request up to retryTimes
        catchError(this.handleError) // then handle the error
      );
    }

    //Send Rerquest for DELETE
    if (method == "DELETE") {
      return this.http.delete(full_url).pipe(
        //retry(this.retryTimes), // retry a failed request up to retryTimes
        catchError(this.handleError) // then handle the error
      );
    }

    //Send Request for POST
    if (method == "DELETE-BODY") {
      let options: any = {};
      options.header = new Headers({
        "Content-Type": "application/json",
      });
      options.body = body;

      return this.http.delete(full_url, options).pipe(
        //retry(this.retryTimes), // retry a failed request up to retryTimes
        catchError(this.handleError) // then handle the error
      );
    }
  }

  //Error Handler Method
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      Logging.error("An error occurred:", error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      Logging.error(`Backend returned code ${error.status}, ` + `body was:`);
      Logging.log(error);
      Logging.log(error.error.message);
      Logging.log(error.status);

      if (error.error.message == "Token Authentication failed") {
        document.getElementById("forceLogout").click();
        return new ErrorObservable(error.error.message);
      }

      if (error.status == 401) {
        Logging.log("here");
        // //Token is unauthorized
        document.getElementById("forceLogout").click();
        return new ErrorObservable(error.error.message);
      }

      if (error.status == 403) {
        // //Action forbidden
        if (error.statusText == "Unauthorized") {
          return new ErrorObservable(error.error.message);
        } else {
          // return new ErrorObservable("Sorry, Something went wrong. Please try again later.");
          return new ErrorObservable(error.error.message);
        }
      }

      if (error.status == 405) {
        Logging.log("Method Not Allowed");
        // //Method Not Allowed
        return new ErrorObservable(
          "Sorry, Something went wrong. Please try again later."
        );
      }

      if (error.status == 500) {
        Logging.log("Internal Server Error");
        // //Method Not Allowed
        return new ErrorObservable(
          "Sorry, Something went wrong. Please try again later."
        );
      }

      if (error.status == 504) {
        Logging.log("Gateway Timeout");
        // //Method Not Allowed
        return new ErrorObservable(
          "Sorry, Something went wrong. Please try again later."
        );
      }

      if (error.status == 400) {
        Logging.log("Bad Request");
        // //Bad Request
        return new ErrorObservable(error.error.message);
      }

      if (error.status == 404) {
        Logging.log("Bad Request");
        // //Bad Request
        return new ErrorObservable(error.error.message);
      }

      // return the error message from the response
      if (error.error.message) {
        return new ErrorObservable(error.error.message);
      } else {
        return new ErrorObservable(
          "Sorry, Something went wrong. Please try again later."
        );
      }
    }
    // return an ErrorObservable with a user-facing error message
    // return new ErrorObservable('Something bad happened; please try again later.');
  }

  //Method for GET Requests
  get(url: string) {
    return this.request(url, "GET");
  }

  //Method for POST Requests
  post(url: string, body: Object) {
    return this.request(url, "POST", body);
  }

  //Method for Put Requests
  put(url: string, body: Object) {
    return this.request(url, "PUT", body);
  }

  //Method for Delete Requests
  delete(url: string) {
    return this.request(url, "DELETE");
  }

  //Method for Delete Requests
  delete_body(url: string, body: Object) {
    return this.request(url, "DELETE-BODY", body);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/api-service/api.service.ts